import React, { useState } from 'react';
import UserGrowthChart from './UserGrowthChart';
import FiveConsultantChart from './FiveConsultantChart';
import ConsultationDistributionMonthlyChart from './ConsultationDistributionMonthlyChart';
import { FormControl, InputLabel, Select as MuiSelect, MenuItem, TextField, IconButton, Tooltip } from "@mui/material";
import { Refresh } from "@mui/icons-material";

const SimpleChartGrid = ({ timeRange, timeRangeStartDate, timeRangeEndDate, onTimeRangeChange, onDateFilterChange, onRefresh }) => {


  const timeRangeOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "last30days", label: "Last 30 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "custom", label: "Custom Range" }
  ];


  return (
  
        <div className="chart-filters" >
          <div style={{ minWidth: '180px', flex: '0 0 auto' }}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>Time Range</InputLabel>
              <MuiSelect
                value={timeRange}
                onChange={(e) => onTimeRangeChange(e.target.value)}
                label="Time Range"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3b82f6',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3b82f6',
                    },
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: '#3b82f6',
                  },
                }}
              >
                {timeRangeOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </MuiSelect>
            </FormControl>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
            <Tooltip title="Refresh Charts">
              <IconButton
                onClick={onRefresh}
                size="small"
                sx={{
                  color: '#3b82f6',
                  '&:hover': {
                    backgroundColor: 'rgba(59, 130, 246, 0.1)',
                  },
                }}
              >
                <Refresh />
              </IconButton>
            </Tooltip>
          </div>
          
          {timeRange === 'custom' && (
            <>
              <div style={{ minWidth: '180px', flex: '0 0 auto' }}>
                <TextField
                  size="small"
                  type="date"
                  variant="outlined"
                  label="Start Date"
                  value={timeRangeStartDate}
                  onChange={(e) => onDateFilterChange('start', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6',
                      },
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: '#3b82f6',
                    },
                  }}
                />
              </div>
              <div style={{ minWidth: '180px', flex: '0 0 auto' }}>
                <TextField
                  size="small"
                  type="date"
                  variant="outlined"
                  label="End Date"
                  value={timeRangeEndDate}
                  onChange={(e) => onDateFilterChange('end', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3b82f6',
                      },
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: '#3b82f6',
                    },
                  }}
                />
              </div>
            </>
          )}
        </div>
    
  );
};

export default SimpleChartGrid;
